// src/components/ProtectedRouteByRole.jsx
import React from "react";
import { Navigate } from "react-router-dom";

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

/**
 * Protege una ruta verificando si el rol del usuario está permitido.
 * @param {string[]} allowedRoles - lista de roles permitidos
 */
const ProtectedRouteByRole = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;

  const payload = parseJwt(token);
  const userRole = payload?.role || localStorage.getItem("role");

  if (!userRole || !allowedRoles.includes(userRole)) {
    // Si no tiene permiso, lo mandamos a /informes (ajusta si quieres otro destino)
    return <Navigate to="/informes" replace />;
  }

  return children;
};

export default ProtectedRouteByRole;
